import React, { useState } from 'react';
import { 
  TextField, 
  IconButton,
  InputAdornment,
  Paper
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const MessageInput = ({ onSendMessage, disabled }) => {
  const [message, setMessage] = useState('');
  
  const handleSend = () => {
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  
  return (
    <Paper
      component="form"
      elevation={0}
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: '24px',
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        placeholder="Message StateShift Pathfinder..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        disabled={disabled}
        InputProps={{
          disableUnderline: true,
          sx: {
            p: 1,
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                color="primary"
                onClick={handleSend}
                disabled={!message.trim() || disabled}
                sx={{ 
                  bgcolor: message.trim() ? 'black' : 'transparent',
                  color: message.trim() ? 'white' : 'text.disabled',
                  '&:hover': {
                    bgcolor: message.trim() ? '#333' : 'transparent',
                  },
                  '&.Mui-disabled': {
                    bgcolor: 'transparent',
                  }
                }}
              >
                <SendIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        variant="outlined"
      />
    </Paper>
  );
};

export default MessageInput;